// import Cube from 'cube-ui'
// import QRCode from 'qrcode'
import {oss,bucketConfig} from '@/utils/oss';

export const defalutMixin = {
  data () {
    return {
      version: '"v1.1.0"',
      subVersion: '"v1.1.1"'
    }
  },
  beforeMount () {
    if (this.$options._componentTag == 'iPage') {
      page.goNextPage = (jsonstring) => {
        var opts = JSON.parse(jsonstring);
        this._go(opts.page, opts.params, undefined, opts.isReplace)
      }
      page.backLastPage = () => { this._back(1000) }
    }
  },
  mounted () {

  },
  destroyed () {

  },
  methods: {
    _getSafeHeight (otherHeight) {
      var top = this._getSafeTop ? this._getSafeTop() : 0;
      return (window.innerHeight - top - otherHeight) + "px";
    },
    _openWEB (title, url, pageDark) {
      try {
        api.openFrame({
          useWKWebView: true,
          animation: {
            type: 'movein',
            subType: 'from_right',
            duration: 200
          },
          name: 'BROWSER',
          url: 'widget://browser.html',
          rect: {
            x: 0,
            y: 0,
            w: api.winWidth,
            h: api.winHeight
          },
          pageParam: { title: title, url: url, dark: !!pageDark },
          allowEdit: false,
          bounces: false,
          bgColor: '#F7F8FA',
          scrollEnabled: false,
          vScrollBarEnabled: false,
          hScrollBarEnabled: false
        })
      } catch (e) {

      }
    },
    _openPDF (url, isDark) {
      try {
        if (api.systemType == 'ios') {
          var reader = api.require('pdfReader');
          reader.open({
            path: url,
            hidden: {
              print: true,
              export: true,
              bookmark: true,
              email: true
            },
            backBtn: {
              size: {
                w: 50,
                h: 36
              },
              bg: {
                normal: 'rgba(255,59,48,1)',
                highlight: 'rgba(0,0,0,0)'
              },
              title: {
                text: '关闭',
                size: 14,
                color: '#FFF',
                alignment: 'center'
              },
              corner: 4
            },
            showLoading: true
          })
        } else {
          api.openFrame({
            useWKWebView: true,
            animation: {
              type: 'movein',
              subType: 'from_bottom',
              duration: 200
            },
            name: 'pdf',
            url: 'widget://pdf.html',
            rect: {
              x: 0,
              y: 0,
              w: api.winWidth,
              h: api.winHeight
            },
            pageParam: {
              pdf: url,
              dark: !!isDark
            },
            allowEdit: false,
            bounces: false,
            bgColor: '#000',
            scrollEnabled: false,
            vScrollBarEnabled: false,
            hScrollBarEnabled: false
          })
        }
      } catch (er) { }
    },
    _requestPower (name, call) {
      api.requestPermission({
        list: [name]
      }, function (ret) {
        if (ret.list && ret.list.filter(x => x.name == name && x.granted).length) {
          call && call()
        } else {

        }
      })
    },
    //打开扫码
    _openScan (opts, isDark) {
      try {
        this._requestPower('camera', function () {
          api.openFrame({
            useWKWebView: true,
            animation: {
              type: 'movein',
              subType: 'from_bottom',
              duration: 200
            },
            name: 'scan',
            url: 'widget://scan.html',
            rect: {
              x: 0,
              y: 0,
              w: api.winWidth,
              h: api.winHeight
            },
            pageParam: opts || { showWrite: true, material: [], dark: !!isDark },
            allowEdit: false,
            bounces: false,
            bgColor: '#000',
            scrollEnabled: false,
            vScrollBarEnabled: false,
            hScrollBarEnabled: false
          })
        })
      } catch (s) { }
    },
    //阿里支付
    _aliPay (orderPayInfo) {
      var aliPayPlus = api.require('aliPayPlus');
      aliPayPlus.payOrder({ orderInfo: orderPayInfo }, function (ret, err) {
        if (ret.code == 9000) {
          page.onAliPaySuccess && page.onAliPaySuccess()
        } else {
          page.onAliPayFail && page.onAliPayFail()
        }
      })
    },
    //微信支付
    // _wxPay(config) {
    //   var wx = api.require('wx');
    //   wx.isInstalled(function (inst) {
    //     if (inst.installed) {
    //       var wxPay = api.require('wxPay');
    //       wxPay.payOrder({
    //         apiKey: config.appId,
    //         orderId: config.prepayId,
    //         mchId: config.partnerId,
    //         nonceStr: config.nonceStr,
    //         timeStamp: config.timeStamp,
    //         package: config.package,
    //         sign: config.sign
    //       }, function (ret, err) {
    //         if (ret.status) {
    //           page.onWxPaySuccess && page.onWxPaySuccess()
    //         } else {
    //           page.onWxPayFail && page.onWxPayFail()
    //         }
    //       })
    //     }
    //   })

    // },
    // _wxShareImage(path, scene) {
    //   var wx = api.require('wx');
    //   wx.shareImage({
    //     apiKey: 'wx4b0c7215be85d3c6',
    //     scene: scene || 'session',
    //     contentUrl: path
    //   }, function (ret, err) {})
    // },
    //生成二维码
    _qrcode (codeurl, call) {
      QRCode.toDataURL(codeurl).then(res => {
        call && call(res)
      })
    },
    //拨打电话
    _call (phonenumber) {
      try {
        api.call({
          type: 'tel_prompt',
          number: phonenumber
        })
      } catch (r) { }
    },
    ///页面跳转
    _go (page, params, anim, isReplace, isNew) {
      if (this && this.$hys) {
        this.$hys.clearLoading();
      }
      this.$nextTick(() => {
        this.$APP.newPage(page, params || {}, anim, isReplace, isNew)
      })
    },
    //跳转到首页
    _goHome (activeTab, params, anim, isReplace, isNew) {
      this.$bus.$emit('homeChangeTab', { activeTab: activeTab, animation: false });
      this._go("Home", params, anim, isReplace, isNew);
    },
    ///返回到前一个页面
    _back () {
      this.$APP.resetPage(1000)
    },
    _remove (page) {
      this.$APP.removePage(page)
    },
    // 打开全屏页面弹窗
    _openPopup (page, params, anim) {
      this.$APP.newPopup(page, params || {}, anim || 'rightIn')
    },
    //关闭全屏页面弹窗
    _colsePopup (page) {
      this.$APP.removePopup(page)
    },
    //打开弹窗
    _openDialog (page, params, anim, cover, coverTap) {
      this.$APP.newDialog(page, params || {}, anim || 'topIn', cover || false, coverTap || false)
    },
    //关闭弹窗
    _colseDialog (page) {
      this.$APP.removeDialog(page)
    },
    ////添加loading
    _loading (msg, isHideMask) {
      const toast = this.$createToast({
        txt: msg ? msg : '请稍候...',
        mask: !isHideMask,
        time: 0
      })
      toast.show();
      return toast;
    },
    //移除loading
    _loadingdone (toast) {
      if (toast) { toast.hide(); }
    },
    _dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    _file (callback, accept, onprocess, onlycamera) {
      var localPage = this;
      try {
        var CallPicker = function (sourceType) {
          api.getPicture({
            sourceType: sourceType,
            encodingType: 'jpg',
            mediaValue: 'pic',
            destinationType: 'base64',
            allowEdit: false,
            quality: 90,
            videoQuality: 'low',
            //targetWidth: 750,
            saveToPhotoAlbum: false
          }, function (ret, err) {
            if (ret && ret.base64Data) {
              var file = localPage._dataURLtoFile(ret.base64Data, 'photo.jpg')
              var data = new FormData();
              data.append('file', file)
              //设置请求头
              let config = {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              };
              localPage.$hys.openLoading();
              localPage.postAction("http://fileyyy.hysyzs.com/Home/FileUpLoad", data, config).then(res => {
                // var mp = ret.base64Data.split(',')
                localPage.$hys.clearLoading();
                // console.log(res.Data)
                if (res.IsSuccess && res.Data) callback && callback(res.Data)
                //data:image/jpg;base64
                // callback && callback(res.data, mp.length > 1 ? 'data:image/jpg;base64,' + mp[1] : 'data:image/jpg;base64,' + mp[
                //   0])
              })
            }
          });
        }
        if (onlycamera) { // 只允许拍照
          localPage._requestPower('camera', function () {
            localPage._requestPower('photos', function () {
              CallPicker('camera')
            })
          });
          return;
        }
        api.actionSheet({
          title: '请选择',
          cancelTitle: '取消',
          buttons: ['拍摄', '从相册选择']
        }, function (ret, err) {
          if (ret.buttonIndex == 1) {
            localPage._requestPower('camera', function () {
              localPage._requestPower('photos', function () {
                CallPicker('camera')
              })
            })
          } else if (ret.buttonIndex == 2) {
            localPage._requestPower('photos', function () {
              CallPicker('album')
            })
          } else {
            return false;
          }
        })
      } catch (ex) {
        var hand = document.getElementById('ImageHandler')
        if (!hand) {
          hand = document.createElement('input')
          hand.style.display = 'none'
          hand.id = 'ImageHandler'
          hand.type = 'file'
          document.body.appendChild(hand)
        }
        hand.accept = accept || "image/*"
        hand.onchange = (e) => {
          var files = e.target.files
          if (files.length) {
            let formdata1 = new FormData();
            // 通过append向form对象添加数据,可以通过append继续添加数据
            //或formdata1.append('file',file);
            formdata1.append("file", files[0], files[0].name);
            //设置请求头
            let config = {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            };
            localPage.$hys.openLoading();
			oss(localPage.getAction.bind(this), {file:files[0]}, bucketConfig['hys-basedata'], window.localStorage.getItem('UserId')).then((resp)=>{
				localPage.$hys.clearLoading();
				if (resp) callback && callback(resp)
			})
            // localPage.postAction("http://fileyyy.hysyzs.com/Home/FileUpLoad", formdata1, config).then(res => {
            //   localPage.$hys.clearLoading();
            //   // console.log(res.Data)
            //   if (res.IsSuccess && res.Data) callback && callback(res.Data)
            // })
          }
          document.body.removeChild(hand)
        }
        hand.dispatchEvent(new MouseEvent('click'))
      }
    },
    __listenPush (userid) {
      var t = this;
      //监听push
      let Tags = ['药约約'];
      try {
        // console.log('+++++++++++++++++++++367'+userid)
        var _guid = userid.replace(/-/g, "")
        var ajpush = api.require('ajpush');
        // ajpush.setListener(
        //   function(ret) {
        //     alert('监听推送',JSON.stringify(ret))
        //   }
        // );
        if (api.systemType == 'ios') {
          Tags = ['药约約', '药约約客户', '药约約IOS客户'];
        } else if (api.systemType == 'android') {
          Tags = ['药约約', '药约約客户', '药约約安卓客户'];
        }
        ajpush.bindAliasAndTags({ alias: _guid, tags: Tags }, function (ret) { })
        if (api.systemType == 'ios') {
          api.addEventListener({ name: 'noticeclicked' }, function (ret, err) {
            if (ret && ret.value) {
              console.log(ret.value.extra)
              var pm = ret.value.extra
              if (pm.page) {
                t._go(pm.page, JSON.parse(pm.query || {}), undefined, false)
              }
            }
          })
        } else if (api.systemType == 'android') {
          api.addEventListener({ name: 'appintent' }, function (ret, err) {
            if (ret && ret.appParam.ajpush) {
              console.log(ret.appParam.ajpush)
              var pm = ret.appParam.ajpush.extra
              if (pm.page) {
                t._go(pm.page, JSON.parse(pm.query || {}), undefined, false)
              }
            }
          })
        }
      } catch (e) { }
    },
    __initAjpush () {
      var t = this;
      // console.log('初始化之前')
      try {
        if (t.auth.getUserId()) {
          // api.notification({
          //   vibrate:[300, 500],
          //   sound:'widget://res/horse.ogg',//自定义声音
          //     notify: {
          //       title: '通知标题', //标题，默认值为应用名称，只Android有效
          //         content: '通知内容', //内容，默认值为'有新消息'
          //         extra:{}, //传递给通知的数据，在通知被点击后，该数据将通过监听函数回调给网页
          //         updateCurrent:false    //是否覆盖更新已有的通知，取值范围true|false。只Android有效
          //     }
          // }, function(ret, err){
          //     if(ret){
          //         alert(JSON.stringify(ret));
          //     }else{
          //         alert(JSON.stringify(err));
          //     }
          // });
          if (api.systemType == 'ios') {
            t.__listenPush(t.auth.getUserId())
          } else if (api.systemType == 'android') {
            var ajpush = api.require('ajpush');
            ajpush.init(function (ret) {
              //console.log('推送初始化')
              if (ret && ret.status) {
                t.__listenPush(t.auth.getUserId())
              }
            })
          }
        } else {
          t.__listenPush("guest")
        }

      } catch (e) { }
    },
    __auth (data) {
      var t = this;
      //console.log('登录之后监听')
      try {
        if (data && data.AccessToken) {
          t.__listenPush(data.UserId)
        } else {
          t.__listenPush("guest")
        }
      } catch (e) { }
    },
    _loginOut () {
      if (page.outing) { return }
      page.outing = true;
      this.__auth({ AccessToken: '' })
      window.localStorage.setItem('alert_history', ''); //清空首页弹窗的记录
      this.$APP.clearAll()
      this.$APP.newPage('Login', {})
      setTimeout(() => { page.outing = false }, 3000);
    },
    __bearer () {
      var ak = this.auth.getToken()
      if (ak) {
        return {
          'Authorization': 'Bearer ' + ak,
          'Platform': 'SApp'
        }
      } else {
        return {
          'Platform': 'SApp'
        }
      }
    },
    __handErr (err, fail) {
      if (err.status == 404) {
        this._Toast("请求地址无效", 2000, "txt", false);
        fail({ ErrorCode: "404" })
      } else if (err.status == 401 || err.status == 403) {
        this._loginOut();
        this._Toast("登录已失效，请重新登录", 2000, "txt", false);
        fail({ ErrorCode: "401" })
      } else {
        this._Toast("请求失败", 2000, "txt", false);
        fail({ ErrorCode: "error" })
      }
    },
    //请求响应后需要做的操作
    __lastdo (response, success, fail) {
      if (response.status == 200) {
        if (response.data.IsSuccess) {
          setTimeout(() => {
            success && success(response.data)
          }, 300);
        } else {
          setTimeout(() => {
            if (response.data.Msg) {
              this._Toast(response.data.Msg || '请求失败', 2000, "txt", false);
            }
            fail && fail({ ErrorCode: "error" })
          }, 300);
        }
      }
    },
    ///弹出
    _Alert (title, content, call, text) {
      var dd = Cube.Dialog.$create({
        type: 'alert',
        title: title ? title : '',
        content: content ? content : '',
        zIndex: 1000,
        icon: '',
        confirmBtn: {
          text: text || '我知道了'
        },
        onConfirm () {
          call && call()
          dd.hide()
          setTimeout(() => {
            dd.remove()
          }, 500);
        }
      }).show()
    },
    ///确认需要输入备注
    _Prompt (title, onConfirm, placeholder, content, type) {
      var dd = Cube.Dialog.$create({
        type: 'prompt',
        title: title ? title : '请输入',
        zIndex: 1000,
        prompt: {
          type: type || 'text',
          value: content,
          placeholder: placeholder ? placeholder : '请输入'
        },
        onCancel: () => {
          dd.hide()
          setTimeout(() => {
            dd.remove()
          }, 500);
        },
        onConfirm: (e, val) => {
          onConfirm && onConfirm(val)
          dd.hide()
          setTimeout(() => {
            dd.remove()
          }, 500);
        }
      }).show()
    },
    //pick
    _Pick (items, call, title, selectedIndex) {
      var dd = this.$createPicker({
        title: title || '请选择',
        selectedIndex: selectedIndex || [0],
        data: [items],
        onSelect (item, index) {
          call && call(items[index[0]], index[0])
          dd.hide()
          setTimeout(() => {
            dd.remove()
          }, 500);
        }
      }).show()
    },
    //sheet
    _Sheet (items, keyName, call) {
      var dd = this.$createActionSheet({
        title: '请选择',
        pickerStyle: true,
        data: items.map(x => { return { content: keyName ? x[keyName] : x, data: x } }),
        onSelect (item, index) {
          call && call(item, index)
          dd.hide()
          setTimeout(() => {
            dd.remove()
          }, 500);
        }
      }).show()
    },
    ///确认框
    _Confirm (title, content, onConfirm, onCancel, confirmText, calcelText) {
      var dd = Cube.Dialog.$create({
        type: 'confirm',
        title: title ? title : '',
        content: content ? content : '',
        zIndex: 100000,
        maskClosable: false,
        confirmBtn: {
          text: confirmText || '确定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        cancelBtn: {
          text: calcelText || '取消',
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        onCancel () {
          onCancel && onCancel()
          dd.hide()
          setTimeout(() => {
            dd.remove()
          }, 500);
        },
        onConfirm () {
          onConfirm && onConfirm()
          dd.hide()
          setTimeout(() => {
            dd.remove()
          }, 500);
        }
      }).show()
    },
    _ImgViewer (items, rindex) {
      var dd = this.$createImagePreview({
        imgs: items,
        "initial-index": rindex || 0,
        loop: false,
        speed: 0,
        hide () {
          setTimeout(() => {
            dd.remove()
          }, 500);
        }
      }).show()
    },
    _Success (txt, dur) {
      this._Toast(txt, dur || 1800, 'correct', false, false)
    },
    _Fail (txt, dur) {
      this._Toast(txt, dur || 1800, 'error', false, false)
    },
    _Tip (txt, dur) {
      this._Toast(txt, dur || 1800, 'txt', false, false)
    },
    //可以消失的气泡提示
    _Toast (txt, time, type, mask, ismaskClose, onTimeout) {
      var dd = Cube.Toast.$create({
        txt: txt ? txt : '拼命加载中',
        time: time ? time : 1000,
        type: type ? type : 'loading',
        zIndex: 100000,
        mask: mask ? mask : false,
        maskClosable: ismaskClose ? ismaskClose : false,
        onTimeout () {
          onTimeout && onTimeout()
          dd.hide()
          setTimeout(() => {
            dd.remove()
          }, 500);
        }
      }).show()
    },
    _IsTel (num) {
      return /^1[23456789]\d{9}$/.test(num);
    },
    _Stamp () {
      return new Date().getTime()
    },
    _Citys (cityData, indexData, callback) {

      var asyncData = [],
        asyncSelectedIndex = [0, 0, 0]
      if (cityData && cityData.length) {
        asyncData = cityData
      }
      if (indexData && indexData.length) {
        asyncSelectedIndex = indexData
      }

      var selectHandle = (selectedVal, selectedIndex, selectedText) => {

      }
      var cancelHandle = () => {

      }
      var changedata = () => {
        Picker.setData(asyncData, asyncSelectedIndex)
        callback([asyncData[asyncSelectedIndex[0]], asyncData[asyncSelectedIndex[0]].children[asyncSelectedIndex[1]], asyncData[
          asyncSelectedIndex[0]].children[asyncSelectedIndex[1]].children[asyncSelectedIndex[2]]], asyncData, asyncSelectedIndex)
      }
      var asyncChangeHandle = (i, index) => {
        if (i == 0) {
          asyncSelectedIndex = [index, 0, 0]
          var p = asyncData[index]
          if (!p.children.length) {
            getCitys(2, p.value)
          } else {
            changedata()
          }
        } else if (i == 1) {
          asyncSelectedIndex = [asyncSelectedIndex[0], index, 0]
          var c = asyncData[asyncSelectedIndex[0]].children[index]
          if (!c.children.length) {
            getCitys(3, c.value)
          } else {
            changedata()
          }
        } else if (i == 2) {
          asyncSelectedIndex = [asyncSelectedIndex[0], asyncSelectedIndex[1], index]
          changedata()
        }
      }

      var buildData = (level, data, code, code2) => {
        if (level == 1) {
          asyncData = data
        } else if (level == 2) {
          asyncData.find(one => one.value == code).children = data
        } else if (level == 3) {
          var cc = asyncData.find(one => one.value == code).children
          cc.find(one => one.value == code2).children = data
        }
      }

      var Picker = this.$createCascadePicker({
        title: '',
        async: true,
        data: asyncData,
        selectedIndex: asyncSelectedIndex,
        onSelect: selectHandle,
        onCancel: cancelHandle,
        onChange: asyncChangeHandle
      })

      var getCitys = (level, code) => {
        level = level || 1
        this._get('api/Bases/GetAdministrativeAreasByCondition', {
          provinceCode: level == 2 ? code : '',
          cityCode: level == 3 ? code : '',
          countyCode: '',
          townCode: '',
          level: level
        }, 'R08').then(res => {
          if (level == 1) {
            var ppp = res.Data.map(x => { return { text: x.Province, value: x.ProvinceCode, children: [] } })
            buildData(1, ppp)
            getCitys(2, ppp[0].value)
          } else if (level == 2) {
            var ccc = res.Data.map(x => { return { text: x.City, value: x.CityCode, children: [] } })
            buildData(2, ccc, res.Data[0].ProvinceCode)
            getCitys(3, ccc[0].value)
          } else if (level == 3) {
            var xxx = res.Data.map(x => { return { text: x.County, value: x.CountyCode } })
            buildData(3, xxx, res.Data[0].ProvinceCode, res.Data[0].CityCode)
            changedata()
            Picker.show()
          }
        })
      }
      if (asyncData && asyncData.length) {
        changedata()
        Picker.show()
      } else {
        getCitys(1, '')
      }
    },

    _CheckAppStatusTheme () {
      //检查页面的状态栏颜色
      setTimeout(() => {
        this.$APP && this.$APP.checkLastPageStatusBar()
      }, 100);
    }
  }
}